module.exports = __webpack_public_path__ + "img/varied_two.186df158.png";